import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpEvent, HttpRequest } from '@angular/common/http';
import { Result } from '../../../shared/result';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class FaremanagementService {

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8'
    })
  };

  constructor(private http: HttpClient) { }
  
  public GetFareManagement(data:any) {
    return this.http.post<Result>(`${environment.apiUrl}/Fare/GetFareManagement`,data, this.httpOptions);
  }  

  public GetFareManagementGrid(data:any) {
    return this.http.post<Result>(`${environment.apiUrl}/Fare/GetFareManagementGrid`,data, this.httpOptions);
  }  

  public async GetBaseFareHistory(data:any) {
    return await this.http.post<Result>(`${environment.apiUrl}/Fare/GetBaseFareHistory`,data, this.httpOptions).toPromise(); 
  }  

  // public async UploadFile(files:any,strGroupID:any){
  //   if (files.length === 0)
  //     return;
  //   const formData = new FormData();
  //   formData.append('strGroupID', strGroupID);
  //   for (let file of files)
  //     formData.append(file.name, file);      

  //     return await  this.http.post<Result>(environment.apiUrl + "/Fare/UploadFile", formData,{
  //     reportProgress: true,
  //   }).toPromise(); 
  // }


  public  DownloadFile(data:any) {    
    const headers = new HttpHeaders()
    .set('Accept', 'application/xlsx; charset=utf-8');
    return   this.http.post(environment.apiUrl + "/Fare/DownloadFareMatrix", data,
    { headers, observe: 'response', responseType: 'blob' }
    );
  }
  
  public async InsertandUpdateFareManagement(data:any) {
    return await this.http.post<Result>(`${environment.apiUrl}/Fare/InsertandUpdateFareManagement`,data, this.httpOptions).toPromise(); 
  }  

  // public async InsertBaseFareMatrix(data:any) {
  //   return await this.http.post<Result>(`${environment.apiUrl}/Fare/InsertBaseFareMatrix`,data, this.httpOptions).toPromise(); 
  // }  

  
  public async InsertBaseFareMatrix(data:any) {
    debugger
    var formData: any = new FormData();
    
    for(let obj in data){      
      formData.append(obj, JSON.stringify(data[obj]));
    }
    formData.append('file', data.file);  
    // formData.append('Content-Type', 'multipart/form-data');
    // formData.append('Accept', '*/*');  
    console.log(formData);
    return await this.http.post<Result>(`${environment.apiUrl}/Fare/InsertBaseFareMatrix`,formData
    ,{
    //   headers: new HttpHeaders({
    //   'Content-Type': 'multipart/form-data'
    // }),
      reportProgress: true
    }
    ).toPromise();
  }

  public async InsertFlatBaseFareMatrix(data:any) {
    return await this.http.post<Result>(`${environment.apiUrl}/Fare/InsertFlatBaseFareMatrix`,data, this.httpOptions).toPromise(); 
  }  
  public async InsertandUpdateComponentWiseFareMatrix(data:any) {
    return await this.http.post<Result>(`${environment.apiUrl}/Fare/InsertandUpdateComponentWiseFareMatrix`,data, this.httpOptions).toPromise(); 
  }  
  public async UpdateFareManagement(data:any) {
    return await this.http.post<Result>(`${environment.apiUrl}/Fare/UpdateFareManagement`,data, this.httpOptions).toPromise(); 
  }  
  public GenerateRouteIntoTriangleMatrix(data:any) {
    return this.http.post<Result>(`${environment.apiUrl}/Fare/GenerateRouteIntoTriangleMatrix`,data, this.httpOptions);
  }  
  public GetFareManagementHistory(data:any) {
    return this.http.post<Result>(`${environment.apiUrl}/Fare/GetFareManagementHistory`,data, this.httpOptions);
  }  

  public GetFareComponentTypeMaster() {
    return this.http.post<Result>(`${environment.apiUrl}/Fare/GetFareComponentTypeMaster`,null, this.httpOptions);
  }  
  public GetFareComponentMaster(data:any) {
    return this.http.post<Result>(`${environment.apiUrl}/Fare/GetFareComponentMaster`,data, this.httpOptions);
  }  
  public GetFareMatrixType() {
    return this.http.post<Result>(`${environment.apiUrl}/Fare/GetFareMatrixTypeMaster`,null, this.httpOptions);
  }  
 
  public GetFareAmountType() {
    return this.http.post<Result>(environment.apiUrl + "/Fare/GetFareAmountType", null,this.httpOptions);
  }
  public GetStationType() {
    return this.http.post<Result>(environment.apiUrl + "/Route/GetStationType", null,this.httpOptions);
  }
  public GetRouteMaster(data:any){
    return this.http.post<Result>(environment.apiUrl + "/Route/GetRouteMaster", data,this.httpOptions); 
  }
  public GetWorkingDaysMaster()
  {
      return this.http.post<Result>(environment.apiUrl + "/ServiceConfiguration/GetWorkingDays", null);
  }
  public GetRefundMatrixMasterDropdown() {

    return this.http.get<Result>((environment.apiUrl)+"/RefundMatrixMaster/GetRefundMatrixMasterDropdown", this.httpOptions);
  }
  public GetEffectiveStartDate_FareManagement(data:any){
    return this.http.post<Result>(environment.apiUrl + "/Fare/GetEffectiveStartDate_FareManagement", data,this.httpOptions); 
  }
  // public GetGeoStructure(data:any) {
  //   return this.http.post<Result>(`${environment.apiUrl}/GeoHierarchyandOrganization/GetGeoStructure`,data, this.httpOptions);
  // }
  // public GetServiceType(data: any) {
  //   return this.http.post<Result>(environment.apiUrl + "/ServiceType/GetServiceType", data,this.httpOptions);
  // }
  // public GetVehicleType(data: any) {
  //   return this.http.post<Result>(environment.apiUrl + "/VehicleManagement/GetVehicleType", data,this.httpOptions);
  // }
  // public GetVehicleSeatTypeMaster() {
  //   return this.http.post<Result>(environment.apiUrl + "/VehicleManagement/GetVehicleSeatTypeMaster", null,this.httpOptions);
  // }
  // public GetTicketCategoryMaster(data:any) {
  //   return this.http.post<Result>(environment.apiUrl + "/TicketCategory/GetTicketCategoryMaster", data,this.httpOptions);
  // }
}
